import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['userSelect', 'userInputs', 'createUserInput', 'firstNameInput', 'lastNameInput', 'emailInput'];

  connect() {
    if (this.hasCreateUserInputTarget) {
      this.toggleFields()
    }
  }

  toggleFields() {
    if (!this.hasCreateUserInputTarget) return;

    const createUser = this.createUserInputTarget.checked && !this.userSelectTarget.value;

    this.userInputsTarget.classList.toggle('hidden', !createUser);
    this.firstNameInputTarget.disabled = !createUser;
    this.lastNameInputTarget.disabled = !createUser;
    this.emailInputTarget.disabled = !createUser;
  }

  createUserInputTargetChanged() {
    this.toggleFields();
  }
}
